import { useUUIDs } from 'hooks/useUUIDs'

/**
 * React hook that generates a UUID
 */
export const useUUID = () => {
  const id = useUUIDs(1)
  return id[0]
}
